import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _07c96d88 = () => interopDefault(import('../../../pages/agendamento.vue' /* webpackChunkName: "pages/agendamento" */))
const _6f7a4798 = () => interopDefault(import('../../../pages/agendamento-online.vue' /* webpackChunkName: "pages/agendamento-online" */))
const _c9cdeeb2 = () => interopDefault(import('../../../pages/app-vidaas.vue' /* webpackChunkName: "pages/app-vidaas" */))
const _1efc5e40 = () => interopDefault(import('../../../pages/cidade/index.vue' /* webpackChunkName: "pages/cidade/index" */))
const _45ee7940 = () => interopDefault(import('../../../pages/compatibilidade.vue' /* webpackChunkName: "pages/compatibilidade" */))
const _5dcffe2b = () => interopDefault(import('../../../pages/compra-pedido.vue' /* webpackChunkName: "pages/compra-pedido" */))
const _5afbcbbe = () => interopDefault(import('../../../pages/contato.vue' /* webpackChunkName: "pages/contato" */))
const _3dec68b6 = () => interopDefault(import('../../../pages/contato-suporte.vue' /* webpackChunkName: "pages/contato-suporte" */))
const _3bcbcbe6 = () => interopDefault(import('../../../pages/delivery.vue' /* webpackChunkName: "pages/delivery" */))
const _7ee8b495 = () => interopDefault(import('../../../pages/disabled.vue' /* webpackChunkName: "pages/disabled" */))
const _075370ae = () => interopDefault(import('../../../pages/documentos-necessarios.vue' /* webpackChunkName: "pages/documentos-necessarios" */))
const _7dd224d9 = () => interopDefault(import('../../../pages/dpn.vue' /* webpackChunkName: "pages/dpn" */))
const _d95629f6 = () => interopDefault(import('../../../pages/dpn-cd.vue' /* webpackChunkName: "pages/dpn-cd" */))
const _12289d8c = () => interopDefault(import('../../../pages/dpn-rfb.vue' /* webpackChunkName: "pages/dpn-rfb" */))
const _2d768420 = () => interopDefault(import('../../../pages/duvidas-frequentes.vue' /* webpackChunkName: "pages/duvidas-frequentes" */))
const _3d9ded00 = () => interopDefault(import('../../../pages/empresa.vue' /* webpackChunkName: "pages/empresa" */))
const _022a6aa2 = () => interopDefault(import('../../../pages/indicacao-de-uso.vue' /* webpackChunkName: "pages/indicacao-de-uso" */))
const _26658a36 = () => interopDefault(import('../../../pages/internacional.vue' /* webpackChunkName: "pages/internacional" */))
const _2c75b873 = () => interopDefault(import('../../../pages/links-importantes.vue' /* webpackChunkName: "pages/links-importantes" */))
const _49503974 = () => interopDefault(import('../../../pages/mapa-site.vue' /* webpackChunkName: "pages/mapa-site" */))
const _ba5e85b2 = () => interopDefault(import('../../../pages/noticias.vue' /* webpackChunkName: "pages/noticias" */))
const _3b30508d = () => interopDefault(import('../../../pages/pagamento-realizado.vue' /* webpackChunkName: "pages/pagamento-realizado" */))
const _5d082b0e = () => interopDefault(import('../../../pages/parceiro-contador.vue' /* webpackChunkName: "pages/parceiro-contador" */))
const _62daa5df = () => interopDefault(import('../../../pages/perguntas-frequentes.vue' /* webpackChunkName: "pages/perguntas-frequentes" */))
const _14739a3b = () => interopDefault(import('../../../pages/politicas.vue' /* webpackChunkName: "pages/politicas" */))
const _e14b1dbc = () => interopDefault(import('../../../pages/renova-nuvem.vue' /* webpackChunkName: "pages/renova-nuvem" */))
const _050e33f2 = () => interopDefault(import('../../../pages/renovacao-online.vue' /* webpackChunkName: "pages/renovacao-online" */))
const _4be9aada = () => interopDefault(import('../../../pages/seja-uma-revenda.vue' /* webpackChunkName: "pages/seja-uma-revenda" */))
const _a92cc736 = () => interopDefault(import('../../../pages/sispass.vue' /* webpackChunkName: "pages/sispass" */))
const _c342151a = () => interopDefault(import('../../../pages/sobre-sdconsulta.vue' /* webpackChunkName: "pages/sobre-sdconsulta" */))
const _110aad7f = () => interopDefault(import('../../../pages/solicitacao-consulta-credito.vue' /* webpackChunkName: "pages/solicitacao-consulta-credito" */))
const _630a7f8a = () => interopDefault(import('../../../pages/solicitacao-link.vue' /* webpackChunkName: "pages/solicitacao-link" */))
const _2a9ceeb8 = () => interopDefault(import('../../../pages/status-pagamento.vue' /* webpackChunkName: "pages/status-pagamento" */))
const _8906fdd8 = () => interopDefault(import('../../../pages/suporte-a1.vue' /* webpackChunkName: "pages/suporte-a1" */))
const _88ce9fd4 = () => interopDefault(import('../../../pages/suporte-a3.vue' /* webpackChunkName: "pages/suporte-a3" */))
const _ba77de74 = () => interopDefault(import('../../../pages/suporte-vidaas.vue' /* webpackChunkName: "pages/suporte-vidaas" */))
const _11a226be = () => interopDefault(import('../../../pages/termoparceria.vue' /* webpackChunkName: "pages/termoparceria" */))
const _b691cb7c = () => interopDefault(import('../../../pages/trabalheConosco.vue' /* webpackChunkName: "pages/trabalheConosco" */))
const _92183802 = () => interopDefault(import('../../../pages/videoconferencia.vue' /* webpackChunkName: "pages/videoconferencia" */))
const _976ed6ee = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _698cdc36 = () => interopDefault(import('../../../pages/blog/_slug.vue' /* webpackChunkName: "pages/blog/_slug" */))
const _7b8f4650 = () => interopDefault(import('../../../pages/cidade/_name.vue' /* webpackChunkName: "pages/cidade/_name" */))
const _bce88e5a = () => interopDefault(import('../../../pages/saiba-mais/_nome.vue' /* webpackChunkName: "pages/saiba-mais/_nome" */))
const _37f19d8d = () => interopDefault(import('../../../pages/_categoria.vue' /* webpackChunkName: "pages/_categoria" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/agendamento",
    component: _07c96d88,
    name: "agendamento"
  }, {
    path: "/agendamento-online",
    component: _6f7a4798,
    name: "agendamento-online"
  }, {
    path: "/app-vidaas",
    component: _c9cdeeb2,
    name: "app-vidaas"
  }, {
    path: "/cidade",
    component: _1efc5e40,
    name: "cidade"
  }, {
    path: "/compatibilidade",
    component: _45ee7940,
    name: "compatibilidade"
  }, {
    path: "/compra-pedido",
    component: _5dcffe2b,
    name: "compra-pedido"
  }, {
    path: "/contato",
    component: _5afbcbbe,
    name: "contato"
  }, {
    path: "/contato-suporte",
    component: _3dec68b6,
    name: "contato-suporte"
  }, {
    path: "/delivery",
    component: _3bcbcbe6,
    name: "delivery"
  }, {
    path: "/disabled",
    component: _7ee8b495,
    name: "disabled"
  }, {
    path: "/documentos-necessarios",
    component: _075370ae,
    name: "documentos-necessarios"
  }, {
    path: "/dpn",
    component: _7dd224d9,
    name: "dpn"
  }, {
    path: "/dpn-cd",
    component: _d95629f6,
    name: "dpn-cd"
  }, {
    path: "/dpn-rfb",
    component: _12289d8c,
    name: "dpn-rfb"
  }, {
    path: "/duvidas-frequentes",
    component: _2d768420,
    name: "duvidas-frequentes"
  }, {
    path: "/empresa",
    component: _3d9ded00,
    name: "empresa"
  }, {
    path: "/indicacao-de-uso",
    component: _022a6aa2,
    name: "indicacao-de-uso"
  }, {
    path: "/internacional",
    component: _26658a36,
    name: "internacional"
  }, {
    path: "/links-importantes",
    component: _2c75b873,
    name: "links-importantes"
  }, {
    path: "/mapa-site",
    component: _49503974,
    name: "mapa-site"
  }, {
    path: "/noticias",
    component: _ba5e85b2,
    name: "noticias"
  }, {
    path: "/pagamento-realizado",
    component: _3b30508d,
    name: "pagamento-realizado"
  }, {
    path: "/parceiro-contador",
    component: _5d082b0e,
    name: "parceiro-contador"
  }, {
    path: "/perguntas-frequentes",
    component: _62daa5df,
    name: "perguntas-frequentes"
  }, {
    path: "/politicas",
    component: _14739a3b,
    name: "politicas"
  }, {
    path: "/renova-nuvem",
    component: _e14b1dbc,
    name: "renova-nuvem"
  }, {
    path: "/renovacao-online",
    component: _050e33f2,
    name: "renovacao-online"
  }, {
    path: "/seja-uma-revenda",
    component: _4be9aada,
    name: "seja-uma-revenda"
  }, {
    path: "/sispass",
    component: _a92cc736,
    name: "sispass"
  }, {
    path: "/sobre-sdconsulta",
    component: _c342151a,
    name: "sobre-sdconsulta"
  }, {
    path: "/solicitacao-consulta-credito",
    component: _110aad7f,
    name: "solicitacao-consulta-credito"
  }, {
    path: "/solicitacao-link",
    component: _630a7f8a,
    name: "solicitacao-link"
  }, {
    path: "/status-pagamento",
    component: _2a9ceeb8,
    name: "status-pagamento"
  }, {
    path: "/suporte-a1",
    component: _8906fdd8,
    name: "suporte-a1"
  }, {
    path: "/suporte-a3",
    component: _88ce9fd4,
    name: "suporte-a3"
  }, {
    path: "/suporte-vidaas",
    component: _ba77de74,
    name: "suporte-vidaas"
  }, {
    path: "/termoparceria",
    component: _11a226be,
    name: "termoparceria"
  }, {
    path: "/trabalheConosco",
    component: _b691cb7c,
    name: "trabalheConosco"
  }, {
    path: "/videoconferencia",
    component: _92183802,
    name: "videoconferencia"
  }, {
    path: "/",
    component: _976ed6ee,
    name: "index"
  }, {
    path: "/blog/:slug?",
    component: _698cdc36,
    name: "blog-slug"
  }, {
    path: "/cidade/:name",
    component: _7b8f4650,
    name: "cidade-name"
  }, {
    path: "/saiba-mais/:nome?",
    component: _bce88e5a,
    name: "saiba-mais-nome"
  }, {
    path: "/:categoria",
    component: _37f19d8d,
    name: "categoria"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
